import React from 'react';
import { type UseRefillCheckupStateReturn } from './useRefillCheckupState';

export const RefillCheckupContext = React.createContext<
  UseRefillCheckupStateReturn | undefined
>(undefined);
